export class BACCarrierOptionData {
    carrierOption = null
    applyToAll = null

    constructor(carrierOption, applyToAll) {
        this.carrierOption = carrierOption
        this.applyToAll = applyToAll
    }
}
